import React, { useMemo } from "react";
import { DESTINATIONS } from "../../data/destinations";
import DestinationCard from "./DestinationCard";

export const DestinationGrid = ({ category = "all" }) => {
  const items = useMemo(() => {
    if (category === "all") return DESTINATIONS;
    return DESTINATIONS.filter((d) => d.category === category);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  return (
    <div data-testid="destination-grid">
      <div className="mb-6 flex items-end justify-between">
        <p data-testid="result-count" className="text-sm text-brand-inkSoft">
          <span className="font-medium text-brand-ink">{items.length}</span> curated
          {category === "all" ? " escapes" : ` ${category} retreats`}
        </p>
        <p className="hidden md:block overline text-brand-inkSoft/70">
          Hand-picked across Europe
        </p>
      </div>
      <div
        className="grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-3"
        key={category}
      >
        {items.map((item, i) => (
          <DestinationCard key={item.id} item={item} index={i} />
        ))}
      </div>
    </div>
  );
};

export default DestinationGrid;
